import useAuth from "../../hooks/useAuth";
import {Navigate, useNavigate, useParams, useSearchParams, useOutletContext, useLocation} from "react-router-dom";
import Input from "../../components/element/Input";
import Textarea from "../../components/element/Textarea";
import InputFile from "../../components/element/InputFile";
import Button from "../../components/element/Button";
import React, {ChangeEvent, useRef} from "react";
import EntityApi from "../../api/EntityApi";
import FileApi from "../../api/FileApi";
import CourseMaterial from "./CourseMaterial";
import {Switch} from "antd";
import BundledEditor from '../../components/BundledEditor';
import config from "../../api/config";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRemove} from "@fortawesome/free-solid-svg-icons";
import { Modal } from 'antd';
import CourseDescriptionTab from "../../modals/CourseDescriptionTab";

const CatalogCourseFormPage = () => {

    const { roles } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = location.state;
    const {id} = useParams();
    const { categoryId } = useOutletContext();
    const [isInvalidName, setIsInvalidName] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [isReload, setIsReload] = React.useState(false);
    const [categories, setCategories] = React.useState([]);

    const [formId, setFormId] = React.useState(0);
    const [formActive, setFormActive] = React.useState(false);
    const [formCode, setFormCode] = React.useState('');
    const [formCategoryId, setFormCategoryId] = React.useState(0);
    const [formName, setFormName] = React.useState('');
    const [formPrice, setFormPrice] = React.useState('');
    const [formDescription, setFormDescription] = React.useState('');
    const [formDescriptionTabs, setFormDescriptionTabs] = React.useState([]);
    const [fileName, setFileName] = React.useState('');
    const [fileUrl, setFileUrl] = React.useState('');
    const [formFile, setFormFile] = React.useState();
    const [formStickerNew, setFormStickerNew] = React.useState(false);
    const [formStickerHit, setFormStickerHit] = React.useState(false);
    const [formStickerTop, setFormStickerTop] = React.useState(false);
    const editorRef = React.useRef(null);
    const [ editor, setEditor ] = React.useState(null);

    const [descTabIndex, setDescTabIndex] = React.useState(null);
    const [descTabTitle, setDescTabTitle] = React.useState('');
    const [descTabContent, setDescTabContent] = React.useState('');
    const [isOpenTabContent, setIsOpenTabContent] = React.useState(false);


    React.useEffect(() => {

        if (categoryId) {
            setFormCategoryId(categoryId);
        }

        EntityApi.getBy('private/category', {filter: {parent: 0}}).then((data) => {
            if (data.status === 'success') {
                let setSelectCategories = [{title: 'Выбрать раздел', id: 0}];
                data.content.items.forEach((item) => {
                    setSelectCategories.push({
                        id: item.id,
                        title: item.title,
                    });
                    item.subitems.forEach((subitem) => {
                        setSelectCategories.push({
                            id: subitem.id,
                            title: '---' + subitem.title,
                        });
                    });
                });
                console.log(setSelectCategories);
                setCategories(setSelectCategories);
            }
        });

        if (id !== undefined && parseInt(id) > 0) {
            setIsLoading(true);
            EntityApi.get('private/product', parseInt(id)).then((data) => {
                setIsLoading(false);
                if (data.status === 'success') {
                    setFormId(data.content.item.id);
                    setFormActive(data.content.item.active);
                    setFormCode(data.content.item.code);
                    setFormName(data.content.item.title);
                    setFormDescription(data.content.item.description);
                    setFormDescriptionTabs(data.content.item.description_tabs);
                    setFormPrice(data.content.item.price);
                    setFormCategoryId(data.content.item.category_id);
                    setFormStickerNew(data.content.item.is_sticker_new);
                    setFormStickerHit(data.content.item.is_sticker_hit);
                    setFormStickerTop(data.content.item.is_sticker_top);
                    if (data.content.item.picture) {
                        setFileName(data.content.item.picture.name + '.' + data.content.item.picture.ext);
                        setFileUrl(data.content.item.picture.url);
                    }
                } else {
                    setIsLoading(false);
                    navigate('/cabinet/catalog/form/course/0');
                }
            }).catch(() => {
                setIsLoading(false);
                navigate('/cabinet/catalog/form/course/0');
            });

        } else {
            setFormId(0);
            setFormActive(false);
            setFormCode('');
            setFormName('');
            setFormDescription('');
            setFormDescriptionTabs([]);
            setFormPrice('');
            setFileName('');
            setFileUrl('');
            setFormFile(undefined);
            setFormStickerNew(false);
            setFormStickerHit(false);
            setFormStickerTop(false);
        }
    }, [id, isReload])

    React.useEffect(() => {
        setEditor(editorRef);
    }, [])

    const submitForm = (fileId) => {

        if (formId > 0) {

            let description = formDescription;

            if (editor && editor.current) {
                description = editor.current.getContent();
            }

            EntityApi.post('private/product', formId, {
                "title": formName,
                "active": formActive,
                "category_id": formCategoryId,
                "description": description,
                "description_tabs": JSON.stringify(formDescriptionTabs),
                "price": formPrice,
                "code": formCode,
                "picture_id": fileId ?? 0,
                'is_sticker_new': formStickerNew,
                'is_sticker_hit': formStickerHit,
                'is_sticker_top': formStickerTop,
            }).then((data) => {
                setIsLoading(false);
                if (data.status === 'success') {
                    navigate('/cabinet/catalog/form/course/' + data.content.item.id);
                    setIsReload(!isReload);
                }
            })
        } else {
            EntityApi.put('private/product', {
                "title": formName,
                "active": formActive,
                "category_id": formCategoryId,
                "description": formDescription,
                "description_tabs": JSON.stringify(formDescriptionTabs),
                "price": formPrice,
                "code": formCode,
                "picture_id": fileId ?? 0,
                'is_sticker_new': formStickerNew,
                'is_sticker_hit': formStickerHit,
                'is_sticker_top': formStickerTop,
            }).then((data) => {
                setIsLoading(false);
                if (data.status === 'success') {
                    navigate('/cabinet/catalog/form/course/' + data.content.item.id);
                }
            })
        }

    }

    const onSubmit = () => {
        setIsLoading(true);

        if (formFile) {
            FileApi.post(formFile).then((data) => {
                if (data.status === 'success') {
                    submitForm(data.content.item.id);
                }
            });
        } else {
            submitForm();
        }

    }

    const handleFile = (e) => {
        if (e.target.files === null) {
            return
        }
        const file = e.target.files[0]
        setFileName(file.name);
        setFormFile(file);
    }

    const handleFormPrice = (value) => {
        let result = value.replace(/\D/g, '');
        setFormPrice(result)
    }

    const onDescriptionTabsAdd = () => {
        let tabs = [...formDescriptionTabs];
        tabs.push({
            title: 'Новая вкладка',
            text: ''
        });
        setFormDescriptionTabs(tabs);
    }

    const onDescriptionTabsRemove = (index) => {
        let tabs = [...formDescriptionTabs];
        tabs.splice(index, 1);
        setFormDescriptionTabs(tabs);
    }

    const onOpenDescriptionTab = (index) => {
        setDescTabIndex(index);
        setDescTabTitle(formDescriptionTabs[index].title)
        setDescTabContent(formDescriptionTabs[index].text)
        setIsOpenTabContent(true);
    }

    const onDescriptionTabsChange = (index, title, content) => {
        let tabs = [...formDescriptionTabs];
        tabs[index] = {
            title: title,
            text: content
        }
        setFormDescriptionTabs(tabs);
        setIsOpenTabContent(false);
    }

    return <>{ roles.includes('ROLE_ADMIN') ?
        <><div className="card">
            {
                isLoading &&
                <div className="app-preloader absolute opacity-50 z-50 grid h-full w-full place-content-center bg-slate-50 dark:bg-navy-900">
                    <div className="app-preloader-inner relative inline-block h-48 w-48"></div>
                </div>
            }
            <div className="flex flex-col items-center space-y-4 border-b border-slate-200 p-4 dark:border-navy-500 sm:flex-row sm:justify-between sm:space-y-0 sm:px-5">
                <h2 className="text-lg font-medium tracking-wide text-slate-700 dark:text-navy-100">
                    { formId > 0 ? `Изменить курс [ID: ${formId}]` : 'Создать новый курс' }
                </h2>
                <div className="flex justify-center space-x-2">
                    <Button text={"Назад"} type={"default"} onClick={() => navigate(locationState ? locationState.prevPath : '/cabinet/catalog/course/' + formId)}/>
                    <Button text={ formId > 0 ? 'Сохранить' : 'Создать' } type={"primary"} onClick={onSubmit}/>
                </div>
            </div>
            <div className={"w-full p-4 sm:p-5"}>
            </div>
            <div className="p-4 sm:p-5 flex">
                <div className={"w-8/12"}>
                    <div className="pb-5 block">
                        <Switch checkedChildren="Активен" value={formActive} onChange={(value) => setFormActive(value)} unCheckedChildren="Не активен"/>
                    </div>
                    <label className="block pb-5">
                        <div className="pb-3 block">
                            <span className="font-medium text-slate-600 dark:text-navy-100">Название</span>
                        </div>
                        <Input type={"text"} value={formName} placeholder={""} onChange={setFormName} isInvalid={isInvalidName} textInvalid={"Пожалуйста, заполните название"}/>
                    </label>
                    <label className="block pb-5">
                    <span className="font-medium text-slate-600 dark:text-navy-100">Раздел курса</span>
                    <select value={formCategoryId} onChange={(event) => setFormCategoryId(parseInt(event.target.value))}
                        className="form-select mt-1.5 w-full rounded-lg border border-slate-300 bg-white px-3 py-2 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:bg-navy-700 dark:hover:border-navy-400 dark:focus:border-accent"
                    >
                        {
                            categories.map((cat, index) => {
                                return (
                                    <option key={index} value={cat.id}>{cat.title}</option>
                                )
                            })
                        }
                    </select>
                </label>
                    <label className="block w-40 pb-5">
                        <div className="pb-3 block">
                            <span className="font-medium text-slate-600 dark:text-navy-100">Код</span>
                        </div>
                        <Input type={"text"} value={formCode} placeholder={""} onChange={(value) => setFormCode(value)} />
                    </label>
                    <label className="block w-40">
                        <div className="pb-3 block">
                            <span className="font-medium text-slate-600 dark:text-navy-100">Стоимость</span>
                        </div>
                        <Input type={"text"} value={formPrice} placeholder={""} onChange={handleFormPrice} />
                    </label>
                    <div className="pb-3 block pt-3">
                        <span className="font-medium text-slate-600 dark:text-navy-100">Описание</span>
                    </div>
                    <BundledEditor
                        onInit={(_evt, editor) => editorRef.current = editor}
                        initialValue={formDescription}
                        init={{
                            height: 300,
                            menubar: false,
                            images_upload_url: config.host + '/api/editor/file',
                            plugins: [
                                'advlist', 'anchor', 'autolink', 'help', 'image', 'link', 'lists',
                                'searchreplace', 'table', 'wordcount'
                            ],
                            toolbar: 'undo redo | blocks | image ' +
                                'bold italic forecolor | alignleft aligncenter ' +
                                'alignright alignjustify | bullist numlist outdent indent | ' +
                                'removeformat | help',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}
                    />

                </div>
                <div className={"w-4/12 pl-4"}>
                    {/*<label className="block pb-5">
                    <div className="pb-3 block">
                        <span className="font-medium text-slate-600 dark:text-navy-100">Описание</span>
                    </div>
                    <Textarea  onChange={setFormDescription} placeholder={""} rows={4} value={formDescription}/>

                </label>*/}
                    <div className="block pb-5">
                        <div className="font-medium text-slate-600 dark:text-navy-100">Сортировка</div>
                        <Switch className={'mt-2 mr-2'} checkedChildren="Вывод в ТОП" value={formStickerTop}
                                onChange={(value) => setFormStickerTop(value)} unCheckedChildren="Вывод в ТОП"/>
                    </div>
                    <div className="block pb-5">
                        <div className="font-medium text-slate-600 dark:text-navy-100">Стикеры</div>
                        <Switch className={'mt-2 mr-2'} checkedChildren="Новинка" value={formStickerNew}
                                onChange={(value) => setFormStickerNew(value)} unCheckedChildren="Новинка"/>
                        <Switch className={'mt-2'} checkedChildren="Хит продаж" value={formStickerHit}
                                onChange={(value) => setFormStickerHit(value)} unCheckedChildren="Хит продаж"/>
                    </div>
                    <label className="block pb-5">
                        <div className="pb-3 block">
                            <span className="font-medium text-slate-600 dark:text-navy-100">Изображение</span>
                        </div>
                        <div className="pb-3 block">
                            <InputFile onChange={handleFile}/>
                        </div>
                        {
                            fileUrl != '' && <img src={fileUrl} alt={fileName} width={100}/>
                        }
                        {
                            fileName != '' && <div>{fileName}</div>
                        }

                    </label>
                    <div>
                        <div>Описание вкладками</div>
                        <div>
                            {
                                formDescriptionTabs.map((descriptionItem, index) => {
                                    return <div key={index} className={'mt-2 flex gap-2'}>
                                        <Button text={descriptionItem.title} onClick={() => onOpenDescriptionTab(index)}/>
                                        <div className={'w-2/12'}>
                                            <Button onClick={() => onDescriptionTabsRemove(index)}
                                                    text={'x'} type={"error"}/>
                                        </div>
                                    </div>
                                })
                            }
                            <div className={'mt-2'}>
                                <Button onClick={() => onDescriptionTabsAdd()} type={'infoLight'} text="+ Добавить"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <Modal title="Редактирование вкладки" width={'50%'} footer={null} open={isOpenTabContent} maskClosable={true} onCancel={() => setIsOpenTabContent(false)}>
                <CourseDescriptionTab index={descTabIndex} title={descTabTitle} content={descTabContent} onChange={onDescriptionTabsChange}/>
            </Modal>
            {
                id != undefined && parseInt(id) > 0 && <CourseMaterial id={parseInt(id)}/>
            }
        </>
        : <Navigate to="/"/>}</>

}

export default CatalogCourseFormPage;
